export default function AboutPage() {
  return (
    <main className="pt-20">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            <a className="flex items-center gap-3" href="/">
              <img 
                alt="Hearts of Love Logo" 
                className="h-12 w-12 object-contain" 
                src="https://static.readdy.ai/image/d681489af65230a5411b61d45fe6420c/ccdb2c3b737983542d07d1620e150fe2.png"
              />
              <div className="flex flex-col">
                <span className="font-serif font-bold text-xl text-pink-600">Hearts of Love</span>
                <span className="text-xs text-gray-600">Hạt cườm nhỏ - Ước mơ lớn</span>
              </div>
            </a>
            <div className="hidden md:flex items-center gap-8">
              <a className="font-medium text-gray-700 hover:text-pink-600 transition-colors whitespace-nowrap" href="/">Trang chủ</a>
              <a className="font-medium text-pink-600 transition-colors whitespace-nowrap" href="/about">Câu chuyện</a>
              <a className="font-medium text-gray-700 hover:text-pink-600 transition-colors whitespace-nowrap" href="/products">Sản phẩm</a>
            </div>
            <a href="https://zalo.me/0976753302" target="_blank" rel="noopener noreferrer" className="hidden md:block px-6 py-2.5 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer bg-pink-500 text-white hover:bg-pink-600">
              Liên hệ ngay
            </a>
            <button className="md:hidden">
              <i className="ri-menu-line text-2xl text-pink-600"></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="py-32 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h1 className="font-serif font-bold text-6xl lg:text-7xl text-secondary mb-6">
              Nơi mọi điều khởi nguồn
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Hành trình từ những hạt cườm nhỏ đến những ước mơ lớn
            </p>
          </div>

          <div className="mb-20">
            <div className="relative aspect-square w-full max-w-2xl mx-auto rounded-3xl overflow-hidden mb-12">
              <img
                src="https://drive.google.com/thumbnail?id=16X6_jED6a_r0ToZHxFX2fZbxUMj6olOz&sz=w2000"
                alt="Cơ sở làm việc tại Mái Ấm Khiếm Thị Nhật Hồng"
                className="w-full h-full object-cover object-center"
              />
            </div>

            <div className="prose prose-lg max-w-none">
              <p className="text-2xl text-secondary leading-relaxed mb-8">
                <strong className="font-semibold text-primary">Hearts of Love</strong> ra đời từ mong muốn tạo ra cơ hội việc làm và thu nhập bền vững cho những người khiếm thị tại Mái Ấm Khiếm Thị Nhật Hồng, Việt Nam.
              </p>

              <p className="text-xl text-gray-700 leading-relaxed mb-6">
                Mỗi người đều có khả năng và giá trị riêng, bất kể hoàn cảnh. Những nghệ nhân khiếm thị của chúng tôi đã chứng minh điều đó qua từng sản phẩm tuyệt đẹp được tạo ra bằng đôi tay khéo léo và trái tim đầy nhiệt huyết.
              </p>

              <p className="text-xl text-gray-700 leading-relaxed mb-6">
                Việc xỏ từng hạt cườm nhỏ là một thử thách lớn đối với người khiếm thị. Họ phải dựa vào xúc giác, sự kiên nhẫn và kỹ năng được rèn luyện qua nhiều tháng. Chỉ cần sai một màu, họ phải tháo ra và làm lại từ đầu. Mỗi sản phẩm hoàn thành là kết quả của hàng giờ, thậm chí hàng tuần kiên trì.
              </p>

              <p className="text-xl text-gray-700 leading-relaxed">
                Khi bạn mua một sản phẩm từ Hearts of Love, bạn không chỉ sở hữu một món đồ thủ công đẹp mắt, mà còn đang góp phần tạo ra thu nhập, niềm tin và hy vọng cho những người đang nỗ lực vượt qua khó khăn để hòa nhập vào cuộc sống.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="font-sans font-bold text-5xl lg:text-6xl text-secondary mb-6">
              Quy trình làm việc
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Từ những hạt cườm nhỏ đến sản phẩm hoàn thiện
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
            <div>
              <div className="relative">
                <div className="text-8xl font-bold text-beige mb-4">01</div>
                <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-2xl mb-4">
                  <i className="ri-palette-line text-3xl text-primary"></i>
                </div>
                <h3 className="font-sans font-bold text-xl text-secondary mb-3">
                  Chuẩn bị vật liệu
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Phân loại hạt cườm theo màu sắc và kích thước. Mỗi màu được đặt vào khay riêng để dễ nhận biết bằng xúc giác.
                </p>
              </div>
            </div>

            <div>
              <div className="relative">
                <div className="text-8xl font-bold text-beige mb-4">02</div>
                <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-2xl mb-4">
                  <i className="ri-hand-heart-line text-3xl text-primary"></i>
                </div>
                <h3 className="font-sans font-bold text-xl text-secondary mb-3">
                  Xỏ từng hạt cườm
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Nghệ nhân khiếm thị dùng xúc giác để xỏ từng hạt cườm theo mẫu. Quá trình này đòi hỏi sự kiên nhẫn và tập trung cao độ.
                </p>
              </div>
            </div>

            <div>
              <div className="relative">
                <div className="text-8xl font-bold text-beige mb-4">03</div>
                <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-2xl mb-4">
                  <i className="ri-shield-check-line text-3xl text-primary"></i>
                </div>
                <h3 className="font-sans font-bold text-xl text-secondary mb-3">
                  Kiểm tra chất lượng
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mỗi sản phẩm được kiểm tra kỹ lưỡng. Nếu phát hiện sai sót, phải tháo ra và làm lại từ đầu.
                </p>
              </div>
            </div>

            <div>
              <div className="relative">
                <div className="text-8xl font-bold text-beige mb-4">04</div>
                <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-2xl mb-4">
                  <i className="ri-gift-line text-3xl text-primary"></i>
                </div>
                <h3 className="font-sans font-bold text-xl text-secondary mb-3">
                  Đóng gói & Giao hàng
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Sản phẩm được đóng gói cẩn thận cùng túi organza và thiệp ý nghĩa, sẵn sàng đến tay khách hàng.
                </p>
              </div>
            </div>
          </div>

          {/* Challenges Section */}
          <div className="bg-beige rounded-3xl p-12 lg:p-16">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="font-sans font-bold text-4xl text-secondary mb-6">
                  Thử thách của nghề
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start gap-4">
                    <div className="w-8 h-8 flex items-center justify-center bg-primary rounded-lg flex-shrink-0 mt-1">
                      <i className="ri-eye-off-line text-white"></i>
                    </div>
                    <p className="text-gray-700 leading-relaxed">
                      Việc xỏ từng hạt cườm nhỏ là vô cùng khó khăn đối với người khiếm thị
                    </p>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-8 h-8 flex items-center justify-center bg-primary rounded-lg flex-shrink-0 mt-1">
                      <i className="ri-time-line text-white"></i>
                    </div>
                    <p className="text-gray-700 leading-relaxed">
                      Mỗi sản phẩm phức tạp có thể mất từ 1-3 ngày để hoàn thành
                    </p>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-8 h-8 flex items-center justify-center bg-primary rounded-lg flex-shrink-0 mt-1">
                      <i className="ri-refresh-line text-white"></i>
                    </div>
                    <p className="text-gray-700 leading-relaxed">
                      Chỉ cần sai một màu cũng phải tháo ra làm lại từ đầu
                    </p>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-8 h-8 flex items-center justify-center bg-primary rounded-lg flex-shrink-0 mt-1">
                      <i className="ri-heart-line text-white"></i>
                    </div>
                    <p className="text-gray-700 leading-relaxed">
                      Mỗi sản phẩm hoàn thành là kết quả của nghị lực và kiên trì
                    </p>
                  </div>
                </div>
              </div>

              <div className="relative h-96 lg:h-full w-full rounded-2xl overflow-hidden">
                <img
                  src="https://drive.google.com/thumbnail?id=1OE-F_foZHa65C4MDpa1VjoUcrUZG0WNN&sz=w2000"
                  alt="Thử thách của nghề xỏ hạt cườm"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Community Impact Section */}
      <section className="py-24 bg-secondary text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="font-sans font-bold text-5xl lg:text-6xl mb-6">
              Giá trị cộng đồng
            </h2>
            <p className="text-xl text-beige/80 max-w-3xl mx-auto leading-relaxed">
              Mỗi sản phẩm bạn mua không chỉ là một món quà, mà là một hành động lan tỏa yêu thương
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
            <div>
              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-white/10 rounded-2xl mx-auto mb-6">
                  <i className="ri-money-dollar-circle-line text-4xl text-primary"></i>
                </div>
                <h3 className="font-sans font-bold text-xl mb-3">Tăng thu nhập</h3>
                <p className="text-beige/70 text-sm leading-relaxed">
                  Mỗi sản phẩm bán ra giúp tăng thêm thu nhập ổn định cho người khiếm thị, giúp họ tự lập về tài chính.
                </p>
              </div>
            </div>

            <div>
              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-white/10 rounded-2xl mx-auto mb-6">
                  <i className="ri-team-line text-4xl text-primary"></i>
                </div>
                <h3 className="font-sans font-bold text-xl mb-3">Cơ hội việc làm</h3>
                <p className="text-beige/70 text-sm leading-relaxed">
                  Tạo ra môi trường làm việc phù hợp, giúp người khiếm thị phát huy khả năng và đóng góp cho xã hội.
                </p>
              </div>
            </div>

            <div>
              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-white/10 rounded-2xl mx-auto mb-6">
                  <i className="ri-heart-3-line text-4xl text-primary"></i>
                </div>
                <h3 className="font-sans font-bold text-xl mb-3">Hòa nhập xã hội</h3>
                <p className="text-beige/70 text-sm leading-relaxed">
                  Góp phần thay đổi nhận thức về người khiếm thị, khẳng định giá trị và khả năng của họ.
                </p>
              </div>
            </div>

            <div>
              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-white/10 rounded-2xl mx-auto mb-6">
                  <i className="ri-lightbulb-line text-4xl text-primary"></i>
                </div>
                <h3 className="font-sans font-bold text-xl mb-3">Truyền cảm hứng</h3>
                <p className="text-beige/70 text-sm leading-relaxed">
                  Lan tỏa thông điệp về sự thấu hiểu, nhân ái và tinh thần vượt khó trong cộng đồng.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white/10 rounded-3xl p-12 lg:p-16 text-center">
            <h3 className="font-serif font-bold text-4xl lg:text-5xl mb-6">
              "Một món quà nhỏ – Một ước mơ lớn"
            </h3>
            <p className="text-xl text-beige/80 leading-relaxed max-w-4xl mx-auto mb-8">
              Khi bạn chọn Hearts of Love, bạn không chỉ mua một sản phẩm thủ công đẹp mắt, mà còn đang chung tay nuôi dưỡng những ước mơ, tạo cơ hội và lan tỏa yêu thương đến những người đang nỗ lực vượt qua khó khăn.
            </p>
            <a
              href="https://zalo.me/0976753302"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-white rounded-full font-medium hover:bg-primary/90 transition-all cursor-pointer whitespace-nowrap"
            >
              Đồng hành cùng chúng tôi
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-pink-500 text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
            <div className="md:col-span-5">
              <h2 className="font-serif font-bold text-5xl mb-2">Hearts of Love</h2>
              <p className="text-pink-100/80 text-base mb-6">Hạt cườm nhỏ - Ước mơ lớn</p>
              <p className="text-pink-100/70 text-sm leading-relaxed mb-8 w-11/12">
                Mỗi sản phẩm thủ công từ Hearts of Love là một câu chuyện về nghị lực, kiên trì và ước mơ hòa nhập của những người khiếm thị tại Mái Ấm Khiếm Thị Nhật Hồng.
              </p>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
                <a href="mailto:xuanthaomtgtd@gmail.com" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-mail-line text-lg"></i>
                </a>
                <a href="tel:0785976111" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-phone-line text-lg"></i>
                </a>
              </div>
            </div>
            <div className="md:col-span-4">
              <div className="space-y-8">
                <div>
                  <h3 className="text-pink-100/60 text-xs uppercase tracking-wider mb-3 font-medium">ĐỊA CHỈ</h3>
                  <p className="text-white text-sm leading-relaxed">Mái Ấm Khiếm Thị Nhật Hồng<br />TP. Hồ Chí Minh, Việt Nam</p>
                </div>
                <div>
                  <h3 className="text-pink-100/60 text-xs uppercase tracking-wider mb-3 font-medium">ĐIỆN THOẠI / ZALO</h3>
                  <p className="text-white text-sm">0785976111 - 0976753302</p>
                </div>
                <div>
                  <h3 className="text-pink-100/60 text-xs uppercase tracking-wider mb-3 font-medium">EMAIL</h3>
                  <p className="text-white text-sm">xuanthaomtgtd@gmail.com</p>
                </div>
              </div>
            </div>
            <div className="md:col-span-3">
              <div className="w-full md:w-9/12 ml-auto">
                <img 
                  alt="Nghệ nhân khiếm thị đang làm việc" 
                  className="w-full h-80 object-cover object-center rounded-xl" 
                  src="https://drive.google.com/thumbnail?id=1ZDXXA1O8fEOn3H6lWiaekm2-WldZelAH&sz=w2000"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-white/20">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-pink-100/60 text-xs">© 2025 Hearts of Love. All rights reserved.</p>
              <div className="flex gap-6">
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-pink-100/60 text-xs hover:text-white transition-colors cursor-pointer">
                  Powered by Readdy
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </main>
  );
}